var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookEvil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      height: 512,
      width: 512
    },
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "",
    style: {},
    transform: "translate(0,0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.998 27.8c-24.004-.13-42.94 15.268-54.732 32.778C27.094 78.653 20.66 98.816 24.684 115.1l.01.04 81.476 318.186c.11-9.534 2.292-19.376 6.22-28.596 4.24-9.948 10.73-19.412 19.245-27.21 7.477-7.44 17.398-13.343 29.234-16.575.002 0 .004 0 .007-.002a77.537 77.537 0 0 1 13.787-2.74l.658-.07 323.2 11.25-126.975-328.56-275.21-12.96a55.866 55.866 0 0 0-2.34-.062zm-.107 18.69c.52.003 1.043.017 1.567.04l263.046 12.39 112.408 290.867-299.46-9.77-.653.07c-26.13 2.814-47.677 15.802-60.554 33.823l-67.42-263.29v-.003c-1.57-6.362 2.12-25.013 11.942-39.6 9.516-14.132 23.03-24.603 39.123-24.525zm17.426 17.403L93.35 69.037l73.06 255.193 17.967-5.142-73.06-255.195zm52.48 19.2c3.22 62.57 46.11 84.672 81.54 87.507l9.07-16.85-43.873-19.943 15.91-8.95c-24.727-2.388-42.9-24.437-62.648-41.765zm180.157 2.948c-10.863 18.29-18.594 40.613-39.375 46.132l10.31 13.844-24.808 16.07 14.943 13.84c29.995-7.382 59.367-33.122 38.93-89.885zm44.406 88.26-33.432 59.067-18.184-40.082-25.455 50.627-50.07-37.266-8.277 35.157-76.937-59.768 46.058 99.145 13.426-21.8 45.862 59.07 19.857-46.41 41.196 47.108 17.785-52.03 20.13 28.827 8.04-121.644zM176.214 376.866c-23.563 2.688-39.208 17.766-46.63 35.19-6.863 16.106-5.658 33.007 1.804 42.7l315.006 10.862c-2.514-13.553-1.82-27.43 2.32-41.203l-21.546-6.818 34.252-20.055a126.91 126.91 0 0 1 7.658-10.48l-292.865-10.195z",
    fill: "#000000",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookEvil);
export default __webpack_public_path__ + "static/media/book_evil.31207c0056f48eba85aff86d91e1389d.svg";
export { ForwardRef as ReactComponent };